interface YouTubeEmbedOptions {
  autoplay?: boolean;
  mute?: boolean;
  controls?: boolean;
  loop?: boolean;
}

export function getYouTubeEmbed(url: any, options?: YouTubeEmbedOptions) {
  if (!url || typeof url !== 'string') {
    console.error('URL inválida:', url);
    return null;
  }

  const {
    autoplay = true,
    mute = true,
    controls = false,
    loop = true,
  } = options || {};

  // Padrões de URL do YouTube
  const patterns = [
    // Formato padrão: https://www.youtube.com/watch?v=ID
    /youtu(?:be\.com|\.be)\/(?:watch\?v=|embed\/|v\/|shorts\/)?([A-Za-z0-9_-]{11})/,
    // Formato live: https://www.youtube.com/live/ID
    /youtube\.com\/live\/([A-Za-z0-9_-]{11})/,
    // Formato embed: https://www.youtube.com/embed/ID
    /youtube\.com\/embed\/([A-Za-z0-9_-]{11})/,
    // Formato curto: youtu.be/ID
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      const videoId = match[1];
      const params = new URLSearchParams({
        rel: '0',
        showinfo: '0',
        autoplay: autoplay ? '1' : '0',
        mute: mute ? '1' : '0',
        controls: controls ? '1' : '0',
        loop: loop ? '1' : '0',
        playlist: videoId,
      });
      return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
    }
  }

  console.error('Nenhum padrão de URL do YouTube encontrado:', url);
  return null;
}
